import { useNavigate } from "react-router-dom";
const Terms = () => {
    const router = useNavigate();
    return (
      <div className="container mx-auto px-4 py-12">
         <button
        onClick={() => router('/')}
        className="mb-8 inline-flex items-center text-primary font-medium hover:underline"
      >
        ← Back
      </button>
        <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
        <div className="prose max-w-none">
          <p>Last updated: March 2024</p>
  
          <h2 className="text-2xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
          <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
  
          <h2 className="text-2xl font-semibold mt-6 mb-4">2. Class Policies</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>All classes must be scheduled in advance</li>
            <li>24-hour cancellation notice is required</li>
            <li>Make-up classes are subject to availability</li>
            <li>Payment is required before class participation</li>
          </ul>
  
          <h2 className="text-2xl font-semibold mt-6 mb-4">3. Safety and Conduct</h2>
          <p>Parents/guardians must ensure:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Children are properly attired for class</li>
            <li>Children follow instructor guidance</li>
            <li>Prompt pick-up after class</li>
          </ul>
  
          <h2 className="text-2xl font-semibold mt-6 mb-4">4. Liability</h2>
          <p>While we take all necessary precautions, participation in physical activities carries inherent risks. By enrolling, you acknowledge and accept these risks.</p>
  
          <h2 className="text-2xl font-semibold mt-6 mb-4">5. Contact</h2>
          <p>For any questions regarding these terms, please contact us at:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Email: info@tumblegym.in</li>
            <li>Phone: +91 7019271281</li>
          </ul>
        </div>
      </div>
    );
  };
  
  export default Terms;